import React from "react";
import { useQuery } from "@apollo/client";
import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";
import { GET_DISTRIBUTION_SYSTEMS } from "../../../queries/archiveQrys/InventoryReportQueries";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const DistributionSystemsTable = ({ systemId }) => {
  const columns = [
    {
      Header: "Distribution System ID",
      accessor: "distributionSystemId"
    },
    {
      Header: "Connection Type",
      accessor: "connectionType"
    }
  ];

  const { loading, error, data } = useQuery(GET_DISTRIBUTION_SYSTEMS, { variables: { systemId } });
  if (loading) return <SkeletonLoader width='100%' />;
  if (error) return <ErrorHandler error={error} />;

  return (
    <>
      {data.getDistributionSystemsBySystemId && data.getDistributionSystemsBySystemId.length > 0 ? (
        <DtsReactTable
          data={data.getDistributionSystemsBySystemId}
          columns={columns}
          headerColor='ddw'
          cypressid='DistributionSystemsTable'
        />
      ) : (
        <span>
          <em>No information on distribution systems was found in the database</em>
        </span>
      )}
    </>
  );
};

export default DistributionSystemsTable;
